import React from 'react';
import { bottomNavConfig } from '../appConfig';
import { ASSETS } from '../assetManifest';

function BottomNav({ app }) {
  return (
    <div className="w-full h-[84px] justify-center items-center inline-flex">
      <div className="w-full h-[84px] relative">
        <div className="w-full h-[84px] relative">
          {/* Main background */}
          <div className="w-full h-[84px] bg-[#222835]" />
          
          {/* Shine effect at top */}
          <div className="w-full h-[4.87px] bg-[#5c6e99]" />
          
          {/* Button backgrounds */}
          <div className="absolute inset-0 flex justify-around items-center">
            {bottomNavConfig.screens.map((item, index) => {
              const isPrimary = item.primary;
              const iconKey = `ui_${item.iconKey}`;
              
              return (
                <div 
                  key={item.id}
                  className={`h-[79.13px] flex flex-col items-center justify-center ${
                    isPrimary 
                      ? "w-28 bg-gradient-to-b from-[#303342] via-[#374056] to-[#374056]" 
                      : "w-[67px] bg-[#374056]"
                  }`}
                  onClick={item.action ? () => app[item.action]() : undefined}
                >
                  <div className="flex flex-col items-center gap-1">
                    <img 
                      src={ASSETS.ui[iconKey].path} 
                      alt={item.label}
                      width={46}
                      height={46}
                      className="text-white"
                    />
                    <div className="text-center text-white text-base font-extrabold font-['Asap'] [text-shadow:_0px_1px_0px_rgb(0_0_0_/_1.00)]">
                      {item.label}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomNav;
